import React, { useEffect, useState } from "react";
import { setTitle } from "../helpers/MetaTag";
import { apiRequest, postData } from "../services/api";
import { useDispatch } from "react-redux";
import { authLogin } from "../store/authSlice";
import { useNavigate } from "react-router";
import Button from "../components/form/Button";
import { useTranslation } from "react-i18next";
import unAuthImage from "../assets/image/unauthorized.png";
import AuthLoader from "../components/loader/AuthLoader";
import { Link } from "react-router-dom";
import Image from "../components/elements/Image";
import { MAIN_LOGO } from "../constant/Constant";

const Authentication = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Authentication"
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({
    status: null,
    message: "",
  });
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  const token = params.get("key");
  const loaderStyles = {
    width: "fit-content",
    fontWeight: "bold",
    fontFamily: "monospace",
    fontSize: "26px",
    color: "#0000",
    background:
      "linear-gradient(90deg, #326E68 calc(50% + 0.5ch), #000 0) right/calc(200% + 1ch) 100%",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    animation: "l7 2s infinite steps(11)",
  };

  const keyframes = `
        @keyframes l7 {
            to { background-position: left; }
        }
    `;

  useEffect(() => {
    const tokenVerification = async () => {
      setLoading(true);
      try {
        const result = await apiRequest({
          method: "POST",
          url: "authentication/login",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (result.status === 200) {
          setLoading(false);
          dispatch(authLogin(result.data));
          localStorage.setItem("accessToken", result?.accessToken);
          localStorage.setItem("role", result?.data?.code);
          if (result?.data?.detailsAccess && result?.data?.detailsId) {
            return navigate(`/company-succession-summary`, {
              search: `?detailsId=${result?.data?.detailsId}`,
            });
          } else {
            return navigate("/dashboard");
          }
        } else {
          setLoading(false);
          setResponseData({ status: 401, message: result.message });
        }
      } catch (error) {
        console.log(error.message);
        setResponseData({ status: 401, message: error.message });
      }
    };
    tokenVerification();
  }, [token]);
  console.log("token", token);
  return (
    <>
      <div className="relative min-h-screen flex items-center justify-center bg-teal-400">
        <div className="absolute inset-0 bg-teal-50 clip-diagonal"></div>

        <div className="relative bg-white rounded-xl shadow-lg p-6 text-center w-[500px]">
          <Link to={"/"}>
            <div className="h-14 w-full flex justify-center object-contain mb-5">
              <Image
                src={MAIN_LOGO}
                alt={""}
                width={"100%"}
                height={"100%"}
                classes={"object-contain object-center"}
              />
            </div>
          </Link>
          {loading && (
            <>
              <div className="flex justify-center items-center mt-8">
                <AuthLoader />
              </div>
              <div className="flex justify-center items-center mt-5">
                <style>{keyframes}</style>
                <div style={loaderStyles}>Authenticating, Please Wait...</div>
              </div>
            </>
          )}
          {!loading && responseData?.status === 401 && (
            <>
              <div className="absolute inset-0 flex items-center justify-center text-[140px] text-teal-300/20 font-extrabold drop-shadow-md pointer-events-none">
                404
              </div>
              <div className="flex items-center justify-center mb-4">
                <div className="w-20 h-20 flex items-center justify-center mt-4">
                  <img
                    src={unAuthImage}
                    alt="Unauthorized"
                    className="w-26 h-26"
                  />
                </div>
              </div>

              <div className="text-xl mt-4 font-bold text-rose-600">
                {responseData?.message ||
                  "You are not authorized to view this page."}
              </div>

              <button
                onClick={() => navigate("/")}
                className="mt-2 px-8 py-2 bg-gradient-to-r from-teal-400 to-teal-600 text-white rounded-full hover:scale-105 transition-transform shadow-md hover:shadow-lg"
              >
                Go Home
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Authentication;
